export default __webpack_public_path__ + "images/f699557f2ed32ab9f697cbbc4936eb17-rewardsBg.png";